import type {SnapshotDal} from '@wix/document-manager-core'
import {replaceWixCodeAppId, transformPagePlatformApplicationByPage} from '@wix/document-manager-utils'
/**
 * @exports utils/saveDataFixer/plugins/pagesPlatformApplicationsDataFixer
 * @type {{exec: function}}
 */
export default {
    exec(dataToSave: any, {currentSnapshotDal}: {currentSnapshotDal: SnapshotDal}) {
        const {pagesPlatformApplications} = dataToSave
        if (pagesPlatformApplications) {
            const clientSpecMap = currentSnapshotDal.getValue({type: 'rendererModel', id: 'clientSpecMap'})
            replaceWixCodeAppId(pagesPlatformApplications, clientSpecMap)
            dataToSave.pagesPlatformApplications = transformPagePlatformApplicationByPage(pagesPlatformApplications)
        }
    }
}
